import { render } from "./paySort.vue?vue&type=template&id=3c1ff74c&scoped=true"
import script from "./paySort.vue?vue&type=script&lang=js"
export * from "./paySort.vue?vue&type=script&lang=js"

import "./paySort.vue?vue&type=style&index=0&id=3c1ff74c&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1ff74c"]])

export default __exports__